import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { RouterPath } from 'src/app/config/global-const'
import { WorkingComponent } from './main/working.component'
// import { AnswerForNewFamilyComponent } from './answer-for-new-family/answer-for-new-family.component'
// import { FamilySurveyComponent } from './family/family-survey.component'
// import { FamilyAnswerDetailComponent } from './family-answer-detail/family-answer-detail.component'
// import { FamilySurveyEditorComponent } from './family-survey-editor/family-survey-editor.component'

const routes: Routes = [
    {
        path: '',

        children: [
            {
                path: '',
                component: WorkingComponent,
            },
        ],
    },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class WorkingRoutingModule {}
